import axiosInstance from "../../../services/axiosInstance";
import axiosInstanceNoToken from "../../../services/axiosInstanceNoToken";


/*export const getSlideshow = async () => {
    const response = await axiosInstance().post('/slideshows', { params });
    return response.data;
};*/

export const getSlideshow = async (params = {}) => {
    const response = await axiosInstanceNoToken.get('/slideshows',  {params} );
    return response.data;
};

export const getProductGroup = async (params = {}) => {
    const response = await axiosInstanceNoToken.get('/products/groups',  {params} );
    return response.data;
};

export const getProducts = async (params = {}) => {
    const response = await axiosInstanceNoToken.get('products/products',  {params} );
    return response.data;
};
export const getDiscountedProducts = async (params = {}) => {
    const response = await axiosInstanceNoToken.get('products/discounts',  {params} );
    return response.data;
};
export const getBrands = async (params = {}) => {
    const response = await axiosInstanceNoToken.get('products/brands',  {params} );
    return response.data;
};
export const searchProducts = async (params = {}) => {
    const response = await axiosInstance.get(`products/search`,  {params} );
    return response.data;
};
export const getLastSearches = async (params = {}) => {
    const response = await axiosInstance.get(`products/last-searches`,  {params} );
    return response.data;
};
export const getAlert = async (params = {}) => {
    const response = await axiosInstanceNoToken.get(`alerts`,  {params} );
    return response.data;
};


export const getOrganizationProperties = async (params = null) => {
    const response = await axiosInstanceNoToken.get('config/properties', {params}  );
    return response.data;
};

export const getStates = async (params = null) => {
    const response = await axiosInstanceNoToken.get('/locations/states', {params} );
    return response.data;
};

export const getCities = async (params = null) => {
    const response = await axiosInstanceNoToken.get('/locations/cities', {params} );
    return response.data;
};

export const checkVendorCity = async (params = null) => {
    const response = await axiosInstanceNoToken.get('/locations/check-vendor-city', {params} );
    return response.data;
};

export const getStories = async (params = null) => {
    const response = await axiosInstanceNoToken.get('/products/stories', {params} );
    return response.data;
};